import { useTranslation } from "react-i18next";
import React from "react";

function LongText({ data }: any) {
  const { t } = useTranslation();
  return (
    <div className="choose-correct">
      {data?.questions &&
        data?.questions?.length > 0 &&
        data?.questions?.map((quiz: any) => (
          <p
            key={quiz?.id}
            className={`font-size-16 line-height-24 text-result`}
          >
            {quiz?.content || t("Không có nội dung", "Không có nội dung")}
          </p>
        ))}
    </div>
  );
}

export default LongText;
